import { Deserializable } from '../protocols/deserializable';
import { AccountTypeIdEnum } from '../enum/shared/account-type-id.enum';
import { BeneficiaryChangeSubmissionData } from './beneficiary-change-submission-data';
import { MemberSubmissionAccount } from '../transactions/member-submission-account';
import { AccountType } from '../transactions/account-type';
import { SubmissionSpousalWaiver } from './submission-spousal-waiver';

export class BeneficiaryChangeSubmission implements Deserializable {
  public affectedAccounts!: MemberSubmissionAccount[];
  public previous!: BeneficiaryChangeSubmissionData;
  public new!: BeneficiaryChangeSubmissionData;
  public accountTypeId!: AccountTypeIdEnum;
  public accountType!: AccountType | null;
  public spousalWaiverRequired!: boolean;
  public submissionSpousalWaivers!: SubmissionSpousalWaiver[];
  public memberSpousalWaivers!: SubmissionSpousalWaiver[];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.previous) {
      this.previous = Deserialize.instanceOf(BeneficiaryChangeSubmissionData, this.previous);
    }

    if (!!this.new) {
      this.new = Deserialize.instanceOf(BeneficiaryChangeSubmissionData, this.new);
    }

    if (this.affectedAccounts?.length) {
      this.affectedAccounts = Deserialize.arrayOf(MemberSubmissionAccount, this.affectedAccounts);
    }

    if (!!this.accountType) {
      this.accountType = Deserialize.instanceOf(AccountType, this.accountType);
    }

    if (this.submissionSpousalWaivers?.length) {
      this.submissionSpousalWaivers = Deserialize.arrayOf(SubmissionSpousalWaiver, this.submissionSpousalWaivers);
    }

    if (this.memberSpousalWaivers?.length) {
      this.memberSpousalWaivers = Deserialize.arrayOf(SubmissionSpousalWaiver, this.memberSpousalWaivers);
    }
  }
}
